import socket from '@/services/socket.js'
import feedItemTransformer from '@/services/transformers/feedItemTransformer.js'

export default {
  /**
   * Get user feed by group id.
   *
   * @param group_id
   * @param params
   * @returns Promise
   */
  getFeedByGroupId(group_id, params) {
    let action = '/feed_items/get_by_group_id'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {...{
          action,
          group_id,
        }, ...params
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        if (data && data.feed_items) {
          let items = data.feed_items.map(item => feedItemTransformer(item))
          resolve(items) 
        }

        // If there is no data about feed items, consider them as an empty array.
        // If there are no feed items in database, the server also sends an empty array.
        resolve([])
      })
    })
  }
}
